import { ITkTopProcedureProps } from "../../../type/componentsType/TkProcedureTable";
import TkTable from "../../atoms/TkTable";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { Box } from "@mui/material";
import "./_style.scss";
import { Link } from "react-router-dom";
import TkButton from "../../atoms/TkButton";
import TkTitle from "../../atoms/TkTitle";
import { useContext } from "react";
import { GlobalContext } from "../../../context/globalContext";

/**
 * テーブル部品（ホーム画面用）
 * TkProcedureTableコンポーネントは、TkTableを拡張してホーム画面用のテーブル部品です。
 * @param {ITkTopProcedureProps} props - TkProcedureTableコンポーネントのプロパティ
 * @param {ReactNode} props.maxHeight - TkProcedureTableコンポーネントの要素の最大高
 * @param {ReactNode} props.procedureList - TkProcedureTableコンポーネントの明細データ
 * @param {ReactNode} props.title - TkProcedureTableコンポーネントのタイトル
 * @param {ReactNode} props.historyLink - TkProcedureTableコンポーネントの手続履歴への遷移先URL
 * @param {string} [props.maxHeight=220] - TkProcedureTableコンポーネントのmaxHeightプロパティ
 * @param {string} [props.title="対応が必要な手続"] - TkProcedureTableコンポーネントのtitleプロパティ
 * @returns TkProcedureTable ボタン部品
 */
export const TkProcedureTable: React.FC<ITkTopProcedureProps> = (props) => {
  const {
    maxHeight = 220,
    procedureList,
    title = "対応が必要な手続",
    historyLink,
    // ページング
    defaultRowsPerPage,
    pagin = false,
    count,
    onPageChange,
    onGetPaginList,
    // ボタン
    buttonText,
    buttonOnClick,
    noDataMessage,
    titleChangeToUpdateDay,
  } = props;
  const { state } = useContext(GlobalContext);
  return (
    <Box className={"tkProcedureTable"}>
      <Box className={`titleLine ${pagin && "titleInPagin"}`}>
        <Box className="titleBox">
          <TkTitle size="small" className="title">
            {title}
          </TkTitle>
          {buttonText && (
            <TkButton
              onClick={buttonOnClick}
              disabled={!state.authInfo?.contractApprovalDate}
              ml
            >
              {buttonText}
            </TkButton>
          )}
        </Box>

        {historyLink && <Link to={historyLink}>手続履歴へ　＞</Link>}
      </Box>
      <TkTable
        maxHeight={maxHeight}
        stickyHeader={true}
        hasBorder={false}
        pagin={pagin}
        defaultRowsPerPage={defaultRowsPerPage}
        count={count}
        onPageChange={onPageChange}
        onGetPaginList={onGetPaginList}
        noDataMessage={noDataMessage}
        headList={[
          { headTitle: "重要", className: "tkProcedureHeaderTitle" },
          { headTitle: "進捗", className: "tkProcedureHeaderTitle" },
          {
            headTitle: titleChangeToUpdateDay ? "更新日" : "対応期日",
            className: "tkProcedureHeaderTitle",
          },
          { headTitle: "手続き名", className: "tkProcedureHeaderTitle" },
          { headTitle: "手続きお知らせ", className: "tkProcedureHeaderTitle" },
          { headTitle: "手続タイミング", className: "tkProcedureHeaderTitle" },
          { headTitle: "対応", className: "tkProcedureHeaderTitle" },
        ]}
        bodyList={procedureList?.map((item) => [
          {
            children: item.important ? (
              <PriorityHighIcon className="tkProcedureImportantIcon" />
            ) : (
              <></>
            ),
            align: "center",
            verticalAlign: "middle",
            width: "70px",
          },
          {
            children: item.progress,
            align: "center",
            verticalAlign: "middle",
            width: "100px",
          },
          {
            children: item.date,
            align: "center",
            verticalAlign: "middle",
            width: "120px",
          },
          {
            children: item.procedureName,
            width: "150px",
          },
          {
            children: (
              <Box
                className={item.link && "tkProcedureMessage"}
                onClick={() => {
                  item.onClickMessage && item.onClickMessage();
                }}
              >
                {item.message}
              </Box>
            ),
          },
          {
            children: item.timing,
            width: "140px",
          },
          {
            children: item.children,
            width: "200px",
            verticalAlign: "middle",
          },
        ])}
      />
    </Box>
  );
};
export default TkProcedureTable;
